import { render, staticRenderFns } from "./LegacyRemoteDomainService.vue?vue&type=template&id=45d861a4&"
import script from "./LegacyRemoteDomainService.vue?vue&type=script&lang=js&"
export * from "./LegacyRemoteDomainService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports